var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup224(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 187,
    viewBox: "0 0 273 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.868164,
    width: 271.184,
    height: 185.955,
    rx: 37.526,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.6526 126.742H67.2241L54.9047 79.7434C54.32 77.5814 53.0784 75.6701 51.2522 74.7693C46.6945 72.5055 41.6722 70.7039 36.1934 69.7952V67.9858H62.6584C66.3109 67.9858 69.0504 70.7039 69.5069 73.8607L75.8989 107.763L92.3194 67.9858H108.291L83.6526 126.742ZM117.425 126.742H101.91L114.686 67.9858H130.201L117.425 126.742ZM150.271 84.2653C150.728 81.1007 153.467 79.2912 156.663 79.2912C161.685 78.8369 167.156 79.7456 171.722 82.0015L174.461 69.3509C169.896 67.5415 164.873 66.6328 160.316 66.6328C145.257 66.6328 134.299 74.7715 134.299 86.0669C134.299 94.6599 142.061 99.1719 147.54 101.89C153.467 104.6 155.75 106.41 155.293 109.12C155.293 113.185 150.728 114.995 146.17 114.995C140.691 114.995 135.212 113.64 130.198 111.376L127.459 124.034C132.938 126.29 138.865 127.199 144.344 127.199C161.229 127.645 171.722 119.515 171.722 107.311C171.722 91.9418 150.271 91.041 150.271 84.2653V84.2653ZM226.021 126.742L213.701 67.9858H200.469C197.729 67.9858 194.99 69.7952 194.077 72.5055L171.264 126.742H187.236L190.424 118.157H210.049L211.875 126.742H226.021ZM202.754 83.8122L207.312 105.957H194.536L202.754 83.8122Z",
    fill: "#172B85"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup224);
export default __webpack_public_path__ + "static/media/Group-224.b292134268e4ae142de8f715514a1fb7.svg";
export { ForwardRef as ReactComponent };